// extracted by mini-css-extract-plugin
export default {"outerContainer":"_3VTP0o","title":"_3P5wlk","menuContainer":"_3lq7sN","container":"_27Bkod","menuItemLink":"_3V4-7R","submenu":"_2vUKvQ"};